(ns ycweb.app.admin.wholesale.common
  (:require
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.format :as dtfmt]
        [clj-time.coerce :as dtcoerce]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs-time.format :as dtfmt]
        [cljs-time.coerce :as dtcoerce]])
   [rum.core :as rum]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.util.comms :as comms]
   [util.string :as str]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as form]
   [ycweb.components.grid :as grid]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.util.core :as yuc]
   [ycweb.util.date :as yud]))

(def it-request-form
  "https://airtable.com/appMqZLOa8BMWoDbf/pagX4yHKvfm6iNzEB/form")

(def api-permissions
  #{"SiteAdmin:Teams:Development"})

(def admin-layout-preferences-cookie "admin_layout_preferences")
(def admin-layout-preferences-cookie-key (keyword admin-layout-preferences-cookie))
(def admin-layout-preferences-cookie-max-age (* 60 60 24 365 2))

(defn- valid-admin-layout-preference? [preference]
  (#{"new" "classic"} preference))

(defn admin-layout-preferences [app-atom]
  #?(:clj
     {}
     :cljs
     (let [preferences (yuc/get-cookie! app-atom admin-layout-preferences-cookie-key)]
       (if (map? preferences) preferences {}))))

(defn admin-layout-preference [app-atom page-key]
  #?(:clj
     nil
     :cljs
     (let [preferences (admin-layout-preferences app-atom)
           preference (get preferences page-key)]
       (when (valid-admin-layout-preference? preference)
         preference))))

(defn save-admin-layout-preference! [app-atom page-key preference]
  #?(:cljs
     (when (valid-admin-layout-preference? preference)
       (yuc/set-cookie!
         app-atom
         admin-layout-preferences-cookie-key
         (assoc (admin-layout-preferences app-atom) page-key preference)
         {:max-age admin-layout-preferences-cookie-max-age}))))

(defn try-new-layout-href
  "The current URL with v2=1 added. Built from the live URL rather than from
   parsed screen params, which urlstate stores still-encoded — re-encoding those
   through urlstate/url adds an escape layer per hop (a space becomes %2520)."
  []
  #?(:clj
     ""
     :cljs
     (let [url (js/URL. (.-href js/window.location))]
       (.set (.-searchParams url) "v2" "1")
       (str (.-pathname url) (.-search url)))))

(defn try-new-layout-props
  "Props for the \"Try new layout\" button. The href is there for middle-click and
   copy-link, but the click handler recomputes from the live URL and navigates
   itself: the href is baked in at render time, so a screen that re-rendered
   before the URL settled would otherwise carry a stale target."
  []
  {:href (try-new-layout-href)
   :class "button--silver"
   ;; The server has no window.location, so the href it renders can't match the
   ;; client's. The click handler is what actually navigates — the attribute is
   ;; only there for middle-click — so let React accept the difference rather
   ;; than warn on every planning screen.
   :custom-attrs {:suppressHydrationWarning true}
   :on-click
   (fn [e]
     #?(:cljs
        (do
          (when e (.preventDefault e))
          (set! (.-href js/window.location) (try-new-layout-href)))
        :clj e))})

(defn redirect-to-new-layout-if-needed! [app-atom page-key params]
  #?(:clj
     false
     :cljs
     (let [v2 (:v2 params)]
       (if (and (= "new" (admin-layout-preference app-atom page-key))
             (not= "1" v2))
         (do
           (let [url (js/URL. (.-href js/window.location))]
             (.set (.-searchParams url) "v2" "1")
             (set! (.-href js/window.location) (.toString url)))
           true)
         false))))

(defn transform-address [{:keys [line1 line2] :as address-details}]
  (->
    address-details
    (assoc
      :line1 (str line1 (when (yuc/presence line2) (str " " line2))))))

(defn service-variation? [line-item]
  (= (:variation/features line-item) "Service"))

(defn status-update-modal [app-atom modal-type {:keys [title text items confirm-text confirm-key confirm-data feedback-type]}]
  (grid/open-modal app-atom modal-type
    (yuc/maybe assoc
      {:title title
       :text
       (cond
         feedback-type
         (feedback/feedback feedback-type
           [:b text]
           (when items
             [:div items]))

         :else
         text)}
      :cancel-text (when (= modal-type :grid/confirm) "Cancel")
      :confirm-text (when (= modal-type :grid/confirm) confirm-text)
      :confirm-key (when (= modal-type :grid/confirm) confirm-key)
      :confirm-data (when (= modal-type :grid/confirm) confirm-data))))

(rum/defc form-disabled < rum/reactive [label base-atom entity-key field-key opts]
  (let [entity-atom (if (coll? entity-key) (rum/cursor-in base-atom entity-key) (rum/cursor base-atom entity-key))]
    [:div.text-input-wrapper
     (form/field-label label {})
     (form/input-raw "" (rum/cursor entity-atom field-key)
       (merge
         {:disabled true
          :read-only true}
         opts))]))

(rum/defc form-textarea < rum/reactive [base-atom entity-key field-key label opts]
  (let [entity-atom (rum/cursor base-atom entity-key)
        field-value (cmn/curact entity-atom field-key)
        form-atom (rum/cursor-in base-atom [:form entity-key])
        error-atom (rum/cursor-in form-atom [field-key :error])
        form-value (cmn/curact form-atom [field-key :value])
        error-msg (rum/react error-atom)
        on-key-down-fn
        (fn [e value]
          (let [event-key (.. e -key)]
            (when (re-matches #"[a-zA-Z]" event-key)
              (cond
                (not= (yuc/presence form-value) (yuc/presence value))
                (swap! base-atom update :unsaved-changes
                  assoc field-key {:old-value form-value :new-value value})

                :else
                (swap! base-atom update :unsaved-changes dissoc field-key)))))
        onblur-fn
        (fn [e value]
          (cond
            (and
              (yuc/presence value)
              (not= (yuc/presence form-value) (yuc/presence value)))
            (swap! base-atom update :unsaved-changes
              assoc field-key {:old-value form-value :new-value value})

            :else
            (swap! base-atom update :unsaved-changes dissoc field-key)))
        field-warning (not= (yuc/presence form-value) (yuc/presence field-value))]
    [:div
     {:class
      (cond
        error-msg ["form-field--error"]
        field-warning ["form-field--warning"])}
     (form/field-label label {})
     (form/textarea-raw (rum/cursor entity-atom field-key)
       (assoc opts
         :onblur-fn onblur-fn
         :on-key-down on-key-down-fn))
     (form/error-block error-atom)]))

(rum/defc form-input < rum/reactive [base-atom entity-key field-key label placeholder opts]
  (let [entity-atom (rum/cursor base-atom entity-key)
        field-value (cmn/curact entity-atom field-key)
        form-atom (rum/cursor-in base-atom [:form entity-key])
        error-atom (rum/cursor-in form-atom [field-key :error])
        form-value (cmn/curact form-atom [field-key :value])
        error-msg (rum/react error-atom)
        on-key-down-fn
        (fn [e value]
          (let [event-key (.. e -key)]
            (when (re-matches #"[a-zA-Z]" event-key)
              (cond
                (not= (yuc/presence form-value) (yuc/presence value))
                (swap! base-atom update :unsaved-changes
                  assoc field-key {:old-value form-value :new-value value})

                :else
                (swap! base-atom update :unsaved-changes dissoc field-key)))))
        onblur-fn
        (fn [e value]
          (cond
            (and
              (yuc/presence value)
              (not= (yuc/presence form-value) (yuc/presence value)))
            (swap! base-atom update :unsaved-changes
              assoc field-key {:old-value form-value :new-value value})

            :else
            (swap! base-atom update :unsaved-changes dissoc field-key)))
        field-warning (not= (yuc/presence form-value) (yuc/presence field-value))]
    [:div.text-input-wrapper
     {:class
      (cond
        error-msg ["form-field--error"]
        field-warning ["form-field--warning"])}
     (form/field-label label {})
     (form/input-raw placeholder (rum/cursor entity-atom field-key)
       (assoc opts
         :onblur-fn onblur-fn
         :on-key-down on-key-down-fn))
     (form/error-block error-atom)]))

(rum/defc form-radio < rum/reactive [base-atom entity-key field-key label opts]
  (let [entity-atom (rum/cursor base-atom entity-key)
        field-value (cmn/curact entity-atom field-key)
        form-atom (rum/cursor-in base-atom [:form entity-key])
        error-atom (rum/cursor-in form-atom [field-key :error])
        form-value (cmn/curact form-atom [field-key :value])
        error-msg (rum/react error-atom)
        ;;TODO - Z: change fn
        change-fn
        (fn [app-atom value]
          (cond
            (not= form-value value)
            (swap! base-atom update :unsaved-changes
              assoc field-key {:old-value form-value :new-value value})

            :else
            (swap! base-atom update :unsaved-changes dissoc field-key)))
        field-warning (not= (yuc/presence form-value) (yuc/presence field-value))]
    [:div.text-input-wrapper
     {:class
      (cond
        error-msg ["form-field--error"]
        field-warning ["form-field--warning"])}
     [:label.checkbox-label
      (form/checkbox-raw
        (rum/cursor entity-atom field-key)
        {:disabled (:disabled? opts)})
      [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
      [:span.checkbox__text
       [:span.checkbox__title label]]]
     (form/error-block error-atom)]))

(defn standardise-date-time [value]
  (when (yuc/presence value)
    (dtfmt/unparse
      (dtfmt/formatter "dd-MM-YYYY HH:mm")
      (yud/to-default-time-zone
        (dtcoerce/to-date-time value)))))

(rum/defc form-date < rum/reactive [app-atom base-path entity-key field-key label opts]
  (let [base-atom (rum/cursor app-atom base-path)
        entity-atom (rum/cursor base-atom entity-key)
        field-value (cmn/curact entity-atom field-key)
        form-atom (rum/cursor-in base-atom [:form entity-key])
        error-atom (rum/cursor-in form-atom [field-key :error])
        form-value (cmn/curact form-atom [field-key :value])
        error-msg (rum/react error-atom)
        change-fn
        (fn [app-atom value]
          (cond
            (not= (standardise-date-time form-value) (standardise-date-time value))
            (do
              (swap! base-atom update :unsaved-changes
                assoc field-key {:old-value field-value :new-value value})
              (when-let [change-fn (:change-fn opts)]
                (change-fn)))

            :else
            (swap! base-atom update :unsaved-changes dissoc field-key)))
        field-warning (not= (standardise-date-time form-value) (standardise-date-time field-value))]
    [:div.text-input-wrapper
     {:class
      (cond
        error-msg ["form-field--error"]
        (and (not (:ignore-changes opts)) field-warning) ["form-field--warning"])}
     (datepicker/datepicker app-atom label "dd/mm/yyyy"
       [base-path entity-key field-key]
       (yuc/maybe assoc
         {:header "Date"
          :disabled (:disabled? opts)
          :datatype :date/dmy
          :error (cmn/curact form-atom [field-key :error])}
         :extra-on-click (when (not (:ignore-changes opts)) change-fn)))]))

(rum/defc form-autocomplete-select < rum/reactive
  [base-atom cursor-key entity-key field-key label selected-option options opts]
  (let [entity-atom (rum/cursor base-atom entity-key)
        field-value (cmn/curact entity-atom field-key)
        form-atom (rum/cursor-in base-atom [:form entity-key])
        form-value (cmn/curact form-atom [field-key :value])
        error-atom (rum/cursor-in form-atom [field-key :error])
        error-msg (rum/react error-atom)
        options-idx (yuc/index-by field-key options)
        change-fn
        (fn [value]
          (let [real-option (get options-idx value)
                saved-option (get options-idx form-value)]
            (cond
              (and
                real-option
                (not= form-value value))
              (swap! base-atom update :unsaved-changes
                assoc field-key {:old-value form-value :new-value value})

              (and
                saved-option
                (not= form-value value))
              (swap! base-atom update :unsaved-changes
                assoc field-key {:old-value form-value :new-value value})

              :else
              (swap! base-atom update :unsaved-changes dissoc field-key))))
        field-warning
        (and
          (or
            (get options-idx (yuc/presence field-value))
            (get options-idx (yuc/presence form-value)))
          (not= (yuc/presence form-value) (yuc/presence field-value)))
        render-fn (:render-fn opts)
        suggestion-atom (rum/cursor base-atom cursor-key)
        filter-fn
        (if (yuc/presence (:filtern-fn opts))
          (:filtern-fn opts)
          #(str/includes? (str/lower-case (render-fn %1)) (str/lower-case %2)))
        filter-with (or filter-fn #(str/includes? (str/lower-case %1) (str/lower-case %2)))]
    [:div.text-input-wrapper
     (form/field-label label {})
     [:div
      {:class
       (cond
         error-msg ["form-field--error"]
         field-warning ["form-field--warning"])}
      (form/inline-autocomplete-field
        (if selected-option
          [:span.u-block.u-margin-top-12.faux-input-combo__placeholder
           (render-fn selected-option)]
          [:span.u-block.u-margin-top-12.faux-input-combo__placeholder "Search for options"])
        suggestion-atom
        (yuc/maybe assoc
          {:disabled (:disabled? opts)
           :select-style? true
           :initial-value options
           :empty-list-hint "No option found."
           :min-count 2
           :item-render-fn (fn [item] (render-fn item))
           :select-fn
           (fn [select-option]
             (let [select-fn (:select-fn opts)]
               (change-fn (get select-option field-key))
               (select-fn select-option)))}
          :change-fn
          (if (yuc/presence (:change-fn opts))
            (:change-fn opts)
            (fn [v]
              (when v
                (reset! suggestion-atom
                  (->>
                    options
                    (filter #(filter-with % v))
                    (take (:match-count opts 20)))))))))
      (form/error-block error-atom)]]))

(rum/defc form-select < rum/reactive [base-atom entity-key field-key label options opts]
  (let [entity-atom (rum/cursor base-atom entity-key)
        field-value (cmn/curact entity-atom field-key)
        form-atom (rum/cursor-in base-atom [:form entity-key])
        form-value (cmn/curact form-atom [field-key :value])
        error-atom (rum/cursor-in form-atom [field-key :error])
        error-msg (rum/react error-atom)
        options-idx (yuc/index-by :value options)
        change-fn
        (fn [e value]
          (let [custom-change-fn (:change-fn opts)
                real-option (get options-idx value)
                saved-option (get options-idx form-value)]
            (cond
              (and
                real-option
                (not= form-value value))
              (swap! base-atom update :unsaved-changes
                assoc field-key {:old-value form-value :new-value value})

              (and
                saved-option
                (not= form-value value))
              (swap! base-atom update :unsaved-changes
                assoc field-key {:old-value form-value :new-value value})

              :else
              (swap! base-atom update :unsaved-changes dissoc field-key))
            (when custom-change-fn
              (custom-change-fn e value))))
        field-warning
        (and
          (or
            (get options-idx (yuc/presence field-value))
            (get options-idx (yuc/presence form-value)))
          (not= (yuc/presence form-value) (yuc/presence field-value)))]
    [:div.text-input-wrapper
     (form/field-label label {})
     [:div
      {:class
       (cond
         error-msg ["form-field--error"]
         field-warning ["form-field--warning"])}
      (form/select-raw (rum/cursor entity-atom field-key)
        (cond
          (yuc/presence (:first-option opts))
          (concat
            [(:first-option opts)]
            options)

          :else
          options)
        (assoc opts
          :change-fn change-fn))
      (form/error-block error-atom)]]))

(rum/defc wholesale-wrapper < rum/reactive
  [app-atom {:keys [confirm-leave main-page main-action current-page-title] :as config} content]
  [:div
   [:ul.u-margin-bottom-30
    {:class (yuc/bem :breadcrumbs [:left])}
    [:li.breadcrumbs__item
     [:a.breadcrumb__link
      (cond
        confirm-leave
        {:on-click
         (fn []
           (grid/dispatch-action app-atom :admin.wholesale/check.unsaved-changes
             {:force-open true
              :custom-footer
              {:right-text "Leave"
               :right-type :web
               :right-options (urlstate/href-props app-atom "teamdashboard" "edisonstone" {})}}))}

        :else
        (urlstate/href-props app-atom "teamdashboard" "edisonstone" {}))
      "Team Dashboard"]]
    [:li.breadcrumbs__item
     (cond
       main-action
       [:a.breadcrumb__link
        (cond
          confirm-leave
          {:on-click
           (fn []
             (grid/dispatch-action app-atom :admin.wholesale/check.unsaved-changes
               {:force-open true
                :custom-footer
                {:right-text "Leave"
                 :right-type :web
                 :right-options (urlstate/href-props app-atom "wholesale" main-action {})}}))}

          :else
          (urlstate/href-props app-atom "wholesale" main-action {}))
        main-page]

       :else
       [:span
        main-page])]
    (when current-page-title
      [:li.breadcrumbs__item
       [:span
        current-page-title]])]
   content])

(rum/defc floating-save-button < rum/reactive [on-click-fn]
  [:div
   {:class (yuc/bem :admin-autosave [:is-open])}
   (buttons/button-web [:span.button__float-label.u-text-oil "Save changes?"]
     (yuc/maybe assoc
       {:style :cta
        :size :large
        :class "button--floating  button--rounded  button--has-float-label"
        :type :span-button
        :icon :save
        :icon-size :large
        :icon-only true}
       :on-click (when on-click-fn on-click-fn)))])

(defn overview-field-errors [field-errors]
  (reduce
    (fn [acc field-error]
      (assoc-in acc [(:field-name field-error) :error] (first (:field-status field-error))))
    {} field-errors))

(defn clean-contents [vec-fields raw-csv]
  (map
    #(->>
       %
       (map (fn [row-value] (str/trim (or row-value ""))))
       (zipmap vec-fields))
    raw-csv))

(defn download-csv [{{:keys [csv-rows filename success message]} :params}]
  (let [datetime (yud/date-format (dt/plus (dt/now) (dt/hours 2)) "YYYYMMdd_HH_mm_ss")]
    (cond
      success
      {:body csv-rows
       :headers
       {"Content-Type" "application/csv"
        "Content-Disposition" (str "inline; filename=\"" (str filename "_" datetime ".csv") "\"")}}

      :else
      {:body (str "Failed: " message)
       :headers {"Content-Type" "text/html"}})))

(defn download-pdf [{{:keys [pdf data filename success message] :as params} :params}]
  (cond
    success
    {:status 200
     :headers
     {"Content-Type" "application/pdf"
      "Content-Disposition" (str "inline; filename=\"" filename ".pdf" "\"")}
     :body (or pdf data)}

    :else
    {:body (str "Failed: " message)
     :headers {"Content-Type" "text/html"}}))

(defn overview-link [app-atom {:keys [entity-uuid permission action display-value]}]
  (let [overview-permission?
        (cmn/has-any-permission? app-atom
          (set (conj api-permissions permission)))]

    (cond
      (and
        (yuc/presence entity-uuid)
        overview-permission?)
      [:a
       (urlstate/href-props app-atom "wholesale" action {:uuid entity-uuid})
       (or display-value "Overview")]

      (and
        (not (yuc/presence entity-uuid))
        overview-permission?)
      [:span display-value]

      (not overview-permission?)
      [:a
       (urlstate/href-on-click #(toaster/open-toast app-atom :error "Incorrect permissions" {}))
       (cond
         (yuc/presence entity-uuid)
         (or display-value "Overview")

         :else
         "N/A")])))

(defmethod grid/action :admin.wholesale/wholesale.editor-disabled [app-atom config _]
  (grid/open-modal app-atom :grid/message
    {:title "Warning"
     :text
     (feedback/feedback :warning
       [:b (:title config)]
       (when (yuc/presence (:msg config))
         [:div
          [:p (:msg config)]]))}))

(defmethod grid/action :admin.wholesale/log.change [app-atom config _]
  (comms/send :admin.wholesale/log.change config))

(defmethod comms/receive :admin.wholesale/log.change [app-atom e]
  (println "event logged"))

(defmethod grid/action :admin.wholesale/wholesale.unauthorised-warning [app-atom {:keys [permission]} _]
  (grid/open-modal app-atom :grid/message
    {:title "Warning"
     :text
     (feedback/feedback :warning
       [:b "Unauthorised"]
       [:div
        [:p
         "If you require access, please request the permission "
         [:b permission]
         " form "
         [:a
          (assoc
            {:style {:color "#00afd1" :text-decoration "underline"}}
            :target "_blank" :href it-request-form) "IT request form"]]])}))

(rum/defc modal-confirm-footer < rum/reactive [app-atom]
  (let [{:keys [cancel-fn confirm-fn] :as config} (:config (rum/react (grid/modal-cursor app-atom)))]
    (grid/button-row
      (merge
        {:left-text (or (:cancel-text config) "Back")
         :left-no-icon true
         :left-fn #(grid/close-modal app-atom)
         :right-text (or (:confirm-text config) "Confirm")
         :right-style (when (:negative config) :negative)
         :right-icon (or (:icon-left config) (:icon-right config))
         :right-icon-placement-left (when (:icon-left config) true)
         :right-no-icon (when-not (and (:icon-left config) (:icon-right config)) true)
         :right-fn
         (cond
           confirm-fn
           #(do
              (grid/close-modal app-atom)
              (confirm-fn app-atom))

           (:confirm-key config)
           #(grid/dispatch-modal-action app-atom (:confirm-key config) (or (:confirm-data config) {}))

           :else
           #(grid/close-modal app-atom))}
        (:custom-footer config)))))

(defmethod grid/modal-config :grid/confirm-leave? [app-atom config _]
  {:body grid/modal-confirm-text
   :footer modal-confirm-footer
   :modal-type :alert})

(defmethod grid/action :admin.wholesale/check.unsaved-changes [app-atom config _]
  (let [unsaved-changes? (not (empty? (:unsaved-changes config)))
        confirm-fn (:confirm-fn config)]
    (cond
      (or (:force-open config) unsaved-changes?)
      (grid/open-modal app-atom :grid/confirm-leave?
        (yuc/maybe assoc
          {:title "Are you sure?"
           :text [:p [:b (:message config "You may have unsaved work, are you sure you want to continue?")]]
           :cancel-text "Cancel"
           :confirm-text "Continue"}
          :confirm-key (:confirm-key config)
          :confirm-data (:confirm-data config)
          :confirm-fn confirm-fn
          :custom-footer (:custom-footer config)))

      confirm-fn
      (confirm-fn)

      :else
      (grid/dispatch-action app-atom (:confirm-key config) (:confirm-data config)))))

(defn attachment-upload-handler [e action entity entity-uuid]
  #?(:clj #(identity entity)
     :cljs
     (let [file (-> e .-target .-files (aget 0))]
       (when file
         (let [reader (js/FileReader.)]
           (set! (.-onload reader)
             (fn [e]
               (let [base64-data
                     (-> e .-target .-result
                       (str/replace #"^data:application/pdf;base64," ""))]
                 (comms/send :admin.wholesale/attachment.upload
                   {:filename (.-name file)
                    :entity entity
                    :entity-uuid entity-uuid
                    :response-action action
                    :data base64-data}))))
           (.readAsDataURL reader file))))))

(defmethod comms/receive :admin.wholesale/attachment.upload [app-atom e]
  (toaster/open-toast app-atom :success "Attachment uploaded" {})
  (when (yuc/presence (:response-action e))
    (grid/dispatch-action app-atom (:response-action e) e)))

(defmethod comms/receive :admin.wholesale/attachment.list [app-atom e]
  (grid/dispatch-action app-atom (:response-action e) e))

(defmethod comms/receive :admin.wholesale/attachment.download [app-atom e]
  #?(:cljs
     (let [{:keys [success data]} e]
       (if success
         (let [content (:content data)
               filename (:filename data)
               content-type (:content-type data)
               byte-array (-> content
                            js/atob
                            (js/Uint8Array.from #(.charCodeAt % 0)))
               blob (js/Blob. #js[byte-array] #js{:type content-type})
               url (.createObjectURL js/URL blob)
               link (.createElement js/document "a")]
           (set! (.-href link) url)
           (set! (.-download link) filename)
           (.appendChild (.-body js/document) link)
           (.click link)
           (.removeChild (.-body js/document) link)
           (.revokeObjectURL js/URL url)
           (toaster/open-toast app-atom :success "Attachment downloaded" {}))
         (toaster/open-toast app-atom :error "Failed to download attachment" {})))
     :clj nil))
